import isNil from "lodash/isNil";

import { GroupClassRegistrationModalTestID } from "@/constants/TestID";
import type { RecommendedGroupClassInstance } from "@/store/api/schedule/groupClasses";
import RecommendedGroupDismissLink from "@/ui/components/groupClasses/series/RecommendedGroupDismissLink";
import { ActionBar, Button, FAIconName } from "@/ui/core";
import { VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

type RecommendedGroupClassRegistrationActionsProps = {
  defaultInstanceId?: string;
  dismissIcon: FAIconName;
  dismissText: string;
  errorMessage?: string;
  isLoading?: boolean;
  onDismiss: () => void;
  onRegister: (args: {
    defaultInstanceId?: string;
    selectedInstance?: RecommendedGroupClassInstance;
  }) => void;
  selectedInstance?: RecommendedGroupClassInstance;
  testID: string;
};

const RecommendedGroupClassRegistrationActions = ({
  defaultInstanceId,
  dismissIcon,
  dismissText,
  errorMessage,
  isLoading,
  onDismiss,
  onRegister,
  selectedInstance,
  testID,
}: RecommendedGroupClassRegistrationActionsProps) => (
  <VStack gap={12} width="100%">
    {isNil(errorMessage) ? null : (
      <ActionBar
        iconName={FAIconName.ExclamationCircle}
        message={errorMessage}
        size="small"
        testID={joinTestIDs(
          testID,
          GroupClassRegistrationModalTestID.errorBanner,
        )}
        variant="critical"
      />
    )}
    <Button
      isDisabled={isLoading}
      isFullWidth
      isLoading={isLoading}
      onPress={() =>
        onRegister({
          defaultInstanceId,
          selectedInstance,
        })
      }
      testID={joinTestIDs(
        testID,
        GroupClassRegistrationModalTestID.registerButton,
      )}
      title="Register for group"
      variant="primary"
    />
    <RecommendedGroupDismissLink
      dismissIcon={dismissIcon}
      dismissText={dismissText}
      onDismiss={onDismiss}
      testID={testID}
    />
  </VStack>
);

export default RecommendedGroupClassRegistrationActions;
